<ui-section containerClass="mb-2 pb-2">
  <div class="toolbar preset-block flex ui-gap">
    <ui-form
      [config]="formConfig"
      (selectChange)="onPresetChange($event)"
      (buttonClick)="resetToDefaults()"
    />
  </div>
</ui-section>

<ui-section>
  <ui-block width="2x" class="panel json-panel">
    <ui-panel [panelTitle]="'Context JSON'" width="2x">
      <textarea
        rows="10"
        [ngModel]="contextInput()"
        (ngModelChange)="onContextChange($event)"
        [class.invalid]="parseError()"
        [attr.aria-invalid]="parseError() ? true : null"
        aria-describedby="context-status"
      ></textarea>

      <div
        id="context-status"
        aria-live="polite"
        *ngIf="parseError(); else contextOk"
        class="error"
      >
        {{ parseError() }}
      </div>
      <ng-template #contextOk>
        <small class="ok">Parsed successfully.</small>
      </ng-template>
    </ui-panel>
  </ui-block>

  <ui-block width="2x" class="panel template-panel">
    <ui-panel [panelTitle]="'Template'" width="2x">
      <textarea
        rows="12"
        [ngModel]="templateInput()"
        (ngModelChange)="onTemplateChange($event)"
      ></textarea>
    </ui-panel>
  </ui-block>

  <ui-block width="2x" class="panel output-panel">
    <ui-panel [panelTitle]="'Output'" width="2x">
      <textarea rows="12" readonly [value]="renderedOutput()"></textarea>
    </ui-panel>
  </ui-block>
</ui-section>


